import React from "react";
import '../radioButton/RadioButton.scss';

const RadioButton = ({checked, onClick, name, value,id}) =>{
    return(
    <>
        <input type="radio" name={name} checked={checked} onClick={onClick} id={id} value={value}/>
    </>
    )
}

export default RadioButton;